export default __webpack_public_path__ + "static/description-on-invoice-819f0e72e7f0b0d35862615e5d484e6e.jpg";